/* Boot.
 *
 * The stylesheet is imported here and nowhere else: base.css pulls tokens.css
 * in with @import, so one import at the entry point is the whole design system,
 * and a second import in a component would only reorder the cascade.
 *
 * BrowserRouter lives here rather than in App so that App is nothing but the
 * chrome and the route table. Real paths, no hash: /episodes/HGR-053 is a URL
 * somebody can send to a friend, and the reverse proxy already rewrites unknown
 * paths to index.html.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import './styles/base.css';

const container = document.getElementById('root');

if (!container) {
  // index.html always has it. If it ever does not, failing loudly here beats
  // twenty minutes spent wondering why the page is blank.
  throw new Error('No #root element in index.html — nothing to mount the station into.');
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
